import { render, staticRenderFns } from "./ActPaypalBotao.vue?vue&type=template&id=85bb6b0a&scoped=true&"
import script from "./ActPaypalBotao.vue?vue&type=script&lang=js&"
export * from "./ActPaypalBotao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bb6b0a",
  null
  
)

export default component.exports